import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Badge, Button, Dropdown } from 'antd';
import { selectAgentStatus, selectIsInitialized, selectIsLoading, selectIsSessionActive, selectUnavailableCodes, useNicStore } from 'stores/nic/stores/nicStore';
import { useNicService } from 'stores/nic/useNicService';
import { convertSecondsToDuration } from 'utils/helpers/dateHelper';
import { useAgentTimer } from './hooks/useAgentTimer';
import { useAgentState } from './hooks/useAgentState';
import { useStatusMenuItems } from './hooks/useStatusMenuItems';
import { NICAuthBtn } from '../NICAuthBtn';
var NICStatusBtn = function () {
    // Store selectors
    var isInitialized = useNicStore(selectIsInitialized);
    var isSessionActive = useNicStore(selectIsSessionActive);
    var isLoading = useNicStore(selectIsLoading);
    var agentStatus = useNicStore(selectAgentStatus);
    var unavailableCodes = useNicStore(selectUnavailableCodes);
    // Services
    var _a = useNicService(), startSession = _a.startSession, endSession = _a.endSession, fetchUnavailableCodes = _a.fetchUnavailableCodes, changeAgentStatus = _a.changeAgentStatus;
    // Custom hooks
    var timeDuration = useAgentTimer(agentStatus);
    var _b = useAgentState(agentStatus), selectedKey = _b.selectedKey, label = _b.label, statusColor = _b.statusColor, badgeStatus = _b.badgeStatus;
    var menuItems = useStatusMenuItems(unavailableCodes, changeAgentStatus, endSession);
    useEffect(function () {
        if (isInitialized)
            fetchUnavailableCodes();
    }, [fetchUnavailableCodes, isInitialized]);
    if (!isInitialized && !isLoading)
        return _jsx(NICAuthBtn, {});
    if (!isSessionActive)
        return (_jsx(Button, { size: "large", onClick: startSession, style: { marginRight: 8 }, loading: isLoading, disabled: isLoading, children: "Start Session" }));
    return (_jsx(Dropdown, { menu: {
            items: menuItems,
            selectable: true,
            defaultSelectedKeys: selectedKey
        }, trigger: ['click'], disabled: !isSessionActive || isLoading, children: _jsxs(Button, { size: "large", loading: isLoading, icon: badgeStatus && _jsx(Badge, { status: badgeStatus }), style: {
                marginRight: 8,
                color: statusColor
            }, children: [label, _jsx("span", { style: { display: 'inline-block', marginLeft: 8 }, children: convertSecondsToDuration(timeDuration) })] }) }));
};
export default NICStatusBtn;
